module.exports = __webpack_public_path__ + "static/media/fastrewind02.0caca5a8.svg";